import Link from 'next/link';

import { ChevronRight } from '@assets/icons';
import { IInfoProps } from '@components/cards/LandingCard/LandingCard';
import CustomIcon from '@components/utils/CustomIcon/index';
import { useCustomMobileDesktopBreakpoint } from '@hooks/hooks';
import { LANDING_BREAKPOINT_VALUE } from '@utils/theme/breakPoint';
import { PaletteColor } from '@utils/types';
import { getCurrencySymbol } from '@utils/utils';

import {
  Discount,
  NumericValuesContainer,
  PriceContainer,
  PriceIndicator,
  NavCarPrice,
  DiscountValue,
  RedDivider,
} from './NavigationCardStyles';

type Props = {
  info: IInfoProps;
  detail?: boolean;
  styles?: {
    textColor?: PaletteColor;
    desktopFontSize?: number;
    mobileFontSize?: number;
    containerDisplayFlex?: boolean;
  };
  isVertical?: boolean;
  onNavigate?: () => void;
};

const NavigationCard = ({
  info,
  styles,
  isVertical = true,
  onNavigate = () => false,
}: Props) => {
  const { sm } = useCustomMobileDesktopBreakpoint(LANDING_BREAKPOINT_VALUE);
  return (
    <NumericValuesContainer>
      <RedDivider width={isVertical ? 6 : 36} height={isVertical ? 36 : 6} />
      {info.discount ? (
        <Discount>
          <DiscountValue>{`%${info.discount}`}</DiscountValue>İNDİRİM
        </Discount>
      ) : null}
      {info.price ? (
        <PriceContainer
          discount={!!info.discount}
          displayFlex={styles?.containerDisplayFlex || false}
        >
          <NavCarPrice
            currency={getCurrencySymbol('TL')}
            price={info.price}
            noLine={true}
            fontsize={
              sm ? styles?.mobileFontSize || 14 : styles?.desktopFontSize || 14
            }
            color={styles?.textColor || 'eclipse'}
          />
          <PriceIndicator color={styles?.textColor || 'eclipse'}>
            {info.subText?.replace(/(tl')/gi, "'")}
            'den itibaren
          </PriceIndicator>
        </PriceContainer>
      ) : (
        info.subText
      )}
      <Link href={info.link as string} onClick={onNavigate} prefetch={false}>
        <CustomIcon
          fill={styles?.textColor || 'black'}
          icon={ChevronRight}
          width={sm ? 13 : 19}
          height={sm ? 13 : 19}
          fontSize={sm ? 13 : 19}
        />
      </Link>
    </NumericValuesContainer>
  );
};

export default NavigationCard;
